import { AdobeDataLayer } from '@cinch/oxd-utils/analytics/src/types'

type Params = AdobeDataLayer['page']['vehicleInformation']
type compareInfo = AdobeDataLayer['page']['compareInformation']

export const getDataLayer = (): AdobeDataLayer | undefined => {
  if (typeof window !== 'undefined') {
    const dl = window.adobeData

    if (dl) {
      return dl
    }
  }
}

export const updateCompareInformation = (data: compareInfo) => {
  const dl = getDataLayer()

  if (dl) {
    dl.page.compareInformation = data
  }
}

export const updateVehicleInformation = (data: Params) => {
  const dl = getDataLayer()

  if (dl) {
    dl.page.vehicleInformation = data
  }
}

export const updateVehicleFilters = (data: Cinch.FilterFormData) => {
  const dl = getDataLayer()

  if (dl) {
    dl.page.vehicleFilters = data
  }
}

export const updateFindVehiclePanel = (data: string) => {
  const dl = getDataLayer()

  if (dl) {
    dl.page.pageInfo.findVehiclePanel = data
  }
}
